module.exports = __webpack_public_path__ + "static/discount-5c29ed474ad9eec10e278415df95c9e5.svg";